import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Button } from './va-button';
import { ConfigurableUi } from '../../configurable-ui';

@Component({
  selector: 'va-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *ngFor="let config of buttons">
      <ng-container *ngIf="!config.link" [ngSwitch]="config.type">
        <button
          *ngSwitchCase="'flat'"
          mat-button
          [attr.data-testid]="config.dataTestId"
          [glxyTooltip]="config.tooltip"
          [tooltipPositions]="config.tooltipPosition"
          [color]="config.color"
          [disabled]="config.disabled"
          [attr.data-pendo]="config.pendo"
          (click)="clicked(config)"
        >
          {{ config.title }}
        </button>
        <button
          *ngSwitchCase="'raised'"
          mat-raised-button
          [attr.data-testid]="config.dataTestId"
          [glxyTooltip]="config.tooltip"
          [tooltipPositions]="config.tooltipPosition"
          [color]="config.color"
          [disabled]="config.disabled"
          [attr.data-pendo]="config.pendo"
          (click)="clicked(config)"
        >
          {{ config.title }}
        </button>
        <ng-container *ngSwitchCase="'icon'">
          <button
            *ngIf="!config.classIcon"
            mat-icon-button
            [attr.data-testid]="config.dataTestId"
            [glxyTooltip]="config.tooltip"
            [tooltipPositions]="config.tooltipPosition"
            [color]="config.color"
            [disabled]="config.disabled"
            [attr.data-pendo]="config.pendo"
            (click)="clicked(config)"
          >
            <mat-icon [style.color]="config.iconColor">{{ config.icon }}</mat-icon>
          </button>
          <button
            *ngIf="config.classIcon"
            mat-icon-button
            [attr.data-testid]="config.dataTestId"
            [glxyTooltip]="config.tooltip"
            [tooltipPositions]="config.tooltipPosition"
            [color]="config.color"
            [disabled]="config.disabled"
            [attr.data-pendo]="config.pendo"
            (click)="clicked(config)"
          >
            <span [class]="config.classIcon" [style.color]="config.iconColor"></span>
          </button>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="config.link && config.link.external" [ngSwitch]="config.type">
        <a
          *ngSwitchCase="'flat'"
          mat-button
          [attr.data-testid]="config.dataTestId"
          [glxyTooltip]="config.tooltip"
          [tooltipPositions]="config.tooltipPosition"
          [color]="config.color"
          [href]="config.link.url"
          [disabled]="config.disabled"
          [attr.data-pendo]="config.pendo"
          [target]="config.link.target"
        >
          {{ config.title }}
        </a>
        <a
          *ngSwitchCase="'raised'"
          mat-raised-button
          [attr.data-testid]="config.dataTestId"
          [glxyTooltip]="config.tooltip"
          [tooltipPositions]="config.tooltipPosition"
          [color]="config.color"
          [href]="config.link.url"
          [disabled]="config.disabled"
          [attr.data-pendo]="config.pendo"
          [target]="config.link.target"
        >
          {{ config.title }}
        </a>
        <ng-container *ngSwitchCase="'icon'">
          <a
            mat-icon-button
            [attr.data-testid]="config.dataTestId"
            [glxyTooltip]="config.tooltip"
            [tooltipPositions]="config.tooltipPosition"
            [color]="config.color"
            [disabled]="config.disabled"
            [href]="config.link.url"
            [attr.data-pendo]="config.pendo"
            [target]="config.link.target"
            (click)="clicked(config)"
          >
            <mat-icon *ngIf="!config.classIcon" [style.color]="config.iconColor">
              {{ config.icon }}
            </mat-icon>
            <span *ngIf="config.classIcon" [class]="config.classIcon" [style.color]="config.iconColor"></span>
          </a>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="config.link && !config.link.external" [ngSwitch]="config.type">
        <a
          *ngSwitchCase="'flat'"
          mat-button
          [attr.data-testid]="config.dataTestId"
          [glxyTooltip]="config.tooltip"
          [tooltipPositions]="config.tooltipPosition"
          [color]="config.color"
          [routerLink]="config.link.url"
          [disabled]="config.disabled"
          [attr.data-pendo]="config.pendo"
          [target]="config.link.target"
        >
          {{ config.title }}
        </a>
        <a
          *ngSwitchCase="'raised'"
          mat-raised-button
          [attr.data-testid]="config.dataTestId"
          [glxyTooltip]="config.tooltip"
          [tooltipPositions]="config.tooltipPosition"
          [color]="config.color"
          [routerLink]="config.link.url"
          [disabled]="config.disabled"
          [attr.data-pendo]="config.pendo"
          [target]="config.link.target"
        >
          {{ config.title }}
        </a>
        <ng-container *ngSwitchCase="'icon'">
          <a
            *ngIf="!config.classIcon"
            mat-icon-button
            [attr.data-testid]="config.dataTestId"
            [glxyTooltip]="config.tooltip"
            [tooltipPositions]="config.tooltipPosition"
            [color]="config.color"
            [disabled]="config.disabled"
            [attr.data-pendo]="config.pendo"
            [routerLink]="config.link.url"
            [target]="config.link.target"
            (click)="clicked(config)"
          >
            <mat-icon *ngIf="!config.classIcon" [style.color]="config.iconColor">{{ config.icon }}</mat-icon>
            <span *ngIf="config.classIcon" [class]="config.classIcon" [style.color]="config.iconColor"></span>
          </a>
        </ng-container>
      </ng-container>
    </ng-container>
  `,
})
export class VaButtonComponent implements ConfigurableUi {
  @Input() config: Button | Button[];

  get buttons(): Button[] {
    if (Array.isArray(this.config)) {
      return this.config;
    } else {
      return [this.config];
    }
  }

  clicked(button: Button): void {
    if (button.onClick) {
      button.onClick();
    }
  }
}
